import { GetterTree } from 'vuex';
import PropertyStoreTypes from "./define-types.store";
import { IReportState } from '../states.store';
const checkSendMessagStatusGetters: GetterTree<IReportState, {}> = <GetterTree<IReportState, {}>>{
    service: (state: IReportState) => state.service,

    /** GET ALL NOTIFICATION */
    [PropertyStoreTypes.Get.GET_NOTIFICATIONS]: (state: IReportState) => {
        return state.reportNotification || [];
    }
}

export default checkSendMessagStatusGetters;